module.exports = __webpack_public_path__ + "static/img/hr_visitor_bg.4e11a665.png";